import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Do you offer price matching or discounts?',
    answer: 'Yes! We pride ourselves on offering the most affordable handicap mobility rates in the area. If you find a lower quote from a licensed competitor, we will do our best to match it. We also offer discounted rates for seniors, veterans, and passengers who book recurring weekly trips.'
  }, {
    question: 'Can you ship or deliver my mobility equipment without a passenger?',
    answer: 'Absolutely. We offer affordable shipping and delivery services for heavy wheelchairs, power scooters, hospital beds, and other medical supplies. Our drivers are trained to safely load, secure, and deliver your equipment anywhere in our service area.'
  }, {
    question: 'How far in advance should I book my ride?',
    answer: 'We recommend booking at least 24 to 48 hours in advance to guarantee availability. However, we do our best to accommodate same-day and urgent requests based on fleet availability. Please call us directly for immediate needs.'
  }, {
    question: 'Do you provide door-to-door or door-through-door service?',
    answer: "We provide premium 'door-through-door' service at no extra cost. This means our drivers will assist you from inside your home, safely into the vehicle, and escort you all the way to the reception desk of your destination."
  }, {
    question: 'Can you transport my electric wheelchair or scooter?',
    answer: 'Yes! Our wheelchair accessible vans are equipped with heavy-duty hydraulic lifts and 4-point Q-Straint tie-down systems that can safely accommodate manual wheelchairs, electric wheelchairs, and mobility scooters.'
  }, {
    question: 'Can a family member or caregiver ride with me?',
    answer: 'Absolutely. One caregiver or family member can ride along at no additional charge. We believe in keeping our services affordable and inclusive for families.'
  }, {
    question: 'Do you accept Medicare or Medicaid?',
    answer: 'We are an approved provider for state Medicaid NEMT programs. Rides must typically be pre-authorized through your Medicaid transportation broker. We also offer flexible payment plans for private pay customers to ensure transportation remains affordable.'
  }, {
    question: 'Are your drivers trained in CPR and First Aid?',
    answer: 'Yes. All Gozie Transportation drivers are required to maintain current CPR and First Aid certifications. They also undergo rigorous training in Passenger Assistance Safety and Sensitivity (PASS) and proper equipment handling.'
  }];
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-374">
      {/* Header */}
      <div className="bg-primary-900 text-white py-16" data-id="element-375">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-376">
          <HelpCircle className="w-16 h-16 mx-auto mb-6 text-primary-300" data-id="element-377" />
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-378">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-primary-100 max-w-2xl mx-auto" data-id="element-379">
            Find answers to common questions about our transportation services,
            booking process, and policies.
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-380">
        <div className="space-y-4" data-id="element-381">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-warm-200 overflow-hidden transition-all duration-200" data-id="element-382">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-inset" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-383">
                <span className="text-lg font-bold text-warm-900 pr-8" data-id="element-384">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-primary-600 flex-shrink-0" data-id="element-385" /> : <ChevronDown className="w-6 h-6 text-warm-400 flex-shrink-0" data-id="element-386" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-387">
                <p className="text-warm-600 leading-relaxed border-t border-warm-100 pt-4" data-id="element-388">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>

        {/* Still have questions CTA */}
        <div className="mt-16 bg-secondary-900 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl" data-id="element-389">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-390">
            Still have questions?
          </h2>
          <p className="text-secondary-100 mb-8 max-w-2xl mx-auto text-lg" data-id="element-391">
            Our dispatch team is available 24/7 to answer any specific questions
            you might have about your transportation needs.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-392">
            <a href="tel:2404132157" data-id="element-393">
              <Button size="lg" className="bg-white text-secondary-900 hover:bg-warm-50 w-full sm:w-auto" data-id="element-394">
                Call (240) 413-2157
              </Button>
            </a>
            <Link to="/contact" data-id="element-395">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-secondary-800 w-full sm:w-auto" data-id="element-396">
                Send us a Message
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}